import { makeStyles } from "tss-react/mui";
const useStyles = makeStyles()(({ tokens })=>({
        symbolItem: {
            '&:hover': {
                backgroundColor: tokens.colors.bg.greyscale.primary
            }
        }
    }));
export { useStyles };
